<template>
  <div class="material-download">
    <div class="material-nav-bar">
      <van-nav-bar title="物料下载" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="container">
      <div class="header">
        <div class="title">物料样式</div>
        <div class="card-list">
          <div v-for="item in materialTheme" class="card" :key="item.id" :class="activeCard === item.id ? 'selected' : ''" @click="switchCard(item.id)">{{ item.name }}</div>
        </div>
      </div>
      <div v-show="!isDefaultCard">
        <div class="hr" />
        <div class="input-row">
          <van-field v-model.trim="storeName" label="自定义标题" maxlength="20" input-align="right" placeholder="最多可输入20个字符" />
        </div>
      </div>
    </div>
    <div v-show="!isDefaultCard" class="img-card" ref="imgCard">
      <div class="img-title">{{ storeName }}</div>
      <img class="img-bg" :src="bgSrc" alt />
      <div class="img-content">
        <div class="p-name">微信扫码办会员</div>
        <img v-if="qrcodeSrc" class="img-qr" :src="qrcodeSrc" alt />
      </div>
    </div>
    <div v-show="isDefaultCard" class="img-card-default" ref="imgCardDefault">
      <van-loading v-if="loading" type="spinner" />
      <img v-if="qrcodeSrc" class="img-qr" :src="qrcodeSrc" alt />
    </div>
    <div v-show="showBtn" class="footer">
      <div class="btn" @click="downloadMaterial">下载物料</div>
    </div>
    <van-overlay :show="showOverlay">
      <van-loading vertical>下载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { getQrCodePicUrl } from '@/api/robot.js'
import { materialTheme } from './utils/dataType'
import { toast } from '@/utils/index'
import { getDrugstoreName } from '@/utils/auth.js'
import { saveImage } from '@/utils/appMe.js'
const drugstoreName = getDrugstoreName()

export default {
  data() {
    return {
      activeCard: 1,
      storeName: drugstoreName,
      materialTheme,
      bgSrc: '',
      qrcodeSrc: '',
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
      showOverlay: false,
      loading: false
    }
  },
  computed: {
    isDefaultCard() {
      return this.activeCard === 1
    },
    isDrugStoreName() {
      return this.storeName === drugstoreName && drugstoreName !== ''
    }
  },
  created() {
    this.getQrCodePicUrl()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    handleResize() {
      if (this.clientHeight > document.documentElement.clientHeight) {
        this.showBtn = false
      } else {
        this.showBtn = true
      }
    },
    async getQrCodePicUrl() {
      try {
        this.loading = true
        const result = await getQrCodePicUrl()
        this.qrcodeSrc = result.qrcodeBase64
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log('getQrCodePicUrl', error)
      }
    },
    switchCard(type) {
      this.activeCard = type
      const item = this.materialTheme.find(item => item.id === type)
      this.bgSrc = item.imgSrc
    },
    downloadMaterial() {
      if (!this.qrcodeSrc) {
        toast('二维码不能为空')
        return
      }
      if (!this.isDefaultCard) {
        if (!this.storeName) {
          toast('请输入物料自定义标题')
          return
        }
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
        if (!reg.test(this.storeName) && !this.isDrugStoreName) {
          toast('标题只能包含中文、数字和英文')
          return
        }
      }
      this.showOverlay = true
      let dom = this.$refs.imgCard
      if (this.isDefaultCard) {
        dom = this.$refs.imgCardDefault
      }
      let devicePixelRatio = 1
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        devicePixelRatio = parseInt(window.devicePixelRatio)
      }
      console.log('devicePixelRatio', devicePixelRatio)
      html2canvas(dom, {
        allowTaint: true,
        useCORS: true,
        scale: devicePixelRatio * 2,
        backgroundColor: null
      }).then(async canvas => {
        const base64Str = canvas.toDataURL('image/png')
        saveImage(base64Str, '', res => {
          //console.log('保存图片回调：', res)
          this.showOverlay = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.material-download {
  background: #f5f7f8;
  width: 375px;
  min-height: 100vh;
  overflow: hidden;
  .material-nav-bar {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
      }
    }
    .van-nav-bar__title {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #30303c;
    }
    .van-hairline--bottom::after {
      border: none;
    }
  }
  .container {
    margin-top: 47px;
    .header {
      background: #fff;
      padding: 16px 15px 5px;
    }
    .card-list {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 8px;
      margin-bottom: 15px;
      .card {
        width: 80px;
        height: 35px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #515163;
        text-align: center;
        border: 1px solid #c9cacb;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &.selected {
          border: 1px solid #408afd;
          &::after {
            position: absolute;
            content: '';
            top: 0;
            right: -1px;
            width: 19px;
            height: 19px;
            background: url('~@/assets/material_checked.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .title {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #515163;
    }
    .input-row {
      height: 50px;
      .van-cell {
        line-height: 30px;
      }
      /deep/ .van-field__label {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #515163;
        min-width: 75px;
      }
      /deep/ .van-field__control {
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #a1a5b0;
      }
    }
  }
  /* 1px 横线*/
  .hr {
    position: relative;
    border: none;
  }

  .hr:after {
    content: '';
    position: absolute;
    top: -2px;
    left: 15px;
    background: #f5f5f5;
    width: 345px;
    height: 2px;
    transform: scaleY(0.5);
    transform-origin: 0 0;
  }
  .footer {
    position: fixed;
    bottom: 0;
    background: #fff;
    height: 70px;
    width: 100%;
    .btn {
      width: 345px;
      height: 45px;
      background: #408afd;
      border-radius: 23px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 13px 15px 12px;
    }
  }
  .img-card-default {
    margin: 100px auto;
    width: 248px;
    height: 248px;
    .img-qr {
      width: 248px;
      height: 248px;
    }
    .van-loading {
      text-align: center;
    }
  }
  .img-card {
    width: 248px;
    height: 361px;
    margin: 14px auto;
    border-radius: 8px;
    position: relative;
    .img-title {
      height: 100px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #000000;
      text-align: center;
      box-sizing: border-box;
      padding: 22px 10px;
      background: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      white-space: pre-wrap;
    }
    .img-content {
      position: absolute;
      top: 120px;
      left: 41px;
    }
    .p-name {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      margin-bottom: 10px;
    }
    .img-qr {
      width: 166px;
      height: 166px;
    }
    .img-bg {
      width: 248px;
      height: 262px;
    }
  }
  .van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .van-loading__text {
    color: #fff;
  }
}
</style>
